const translations = {
	page_title: "Accueil",
};

export default translations;
